import { useQuery } from '@tanstack/react-query'
import { keys } from '@/api/hooks/shared/keys'
import { useViewerCurrency } from '@/api/hooks/shared/useViewerCurrency'
import { loadCreditLimitTransfers } from './clTransfersData'
import type { CreditLimitTransferQuery } from './clTransfersTypes'

/**
 * CL Transfers — Winner credit-limit change log.
 *
 * Live Keycloak → Agent-API `searchCreditLimitLogs`. Demo → local fixtures.
 * Unreachable / undeployed hierarchy → unavailable (never invents money rows).
 */
export function useCreditLimitTransfers(query: CreditLimitTransferQuery) {
  const currency = useViewerCurrency()
  return useQuery({
    queryKey: keys.creditLimitTransfers({ ...query, currency }),
    queryFn: () => loadCreditLimitTransfers(query, currency),
    placeholderData: (previous) => previous,
    retry: false,
  })
}
